export const hasDrugManufacturerIdSelected = (ids) => {
    if (Array.isArray(ids)) {
        if (ids?.length > 0) return true;
        return false;
    } else {
        return !!ids
    }
};
